<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'messages.noti_export_data_customer' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <div style="padding: 10px 10px 30px 10px; font-size: 16px; max-height: 400px; overflow-y: auto;" class="row">
    <div>{{'messages.request_export_data_success' | translate}}</div>
    <div [innerHTML]="'messages.router_screen_view_result' | translate"></div>
  </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
  
  
  <div mat-dialog-actions class="justify-content-center">
    <button mat-stroked-button color="primary" class="font-weight-bold" type="button" (click)="closeDialog()" cdkFocusInitial>
      <mat-icon>cancel</mat-icon>{{'as_address.buttons.close' | translate}}
    </button>
  </div>
  